import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';

// Placeholder cards: real trainer quotes are still pending.
// Replace each entry with the actual quote, name and club before publishing.
const testimonials = [1, 2, 3, 4, 5, 6];
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-151" data-mp="1r0ubama7tyja">
      <Reveal className="mx-auto max-w-6xl" data-id="element-152" data-mp="1qz9ib13junnj">
        <div className="mb-12 text-center" data-id="element-153" data-mp="1d0ta15q1gp3a">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-moss" data-id="element-154" data-mp="1d47f4lq37cef">
            FAVORIET ONDER TRAINERS
          </p>
          <h2 className="text-3xl font-black text-brand-green md:text-4xl" data-id="element-155" data-mp="141ohcg15rpz1">
            Wat Hockeytrainers Zeggen.
          </h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-156" data-mp="1839yidkq6qf1">
            ⭐⭐⭐⭐⭐ Gemaakt voor doordacht en zelfverzekerd hockeytrainen
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-157" data-mp="32havsu0mn5d0">
          {testimonials.map(index => <article key={index} className="flex min-h-[220px] flex-col rounded-2xl border border-dashed border-brand-dark bg-brand-main p-7" data-id="element-158" data-mp="2v0sw7ddrmc5h">
              <div className="flex gap-1" data-id="element-159" data-mp="34r48pobiltnz">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-160" data-mp="2zskp3uke8tys" />)}
              </div>
              <p className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-brand-gray" data-id="element-161" data-mp="274otkt6k983l">
                “[Citaat volgt]”
              </p>
              <div className="mt-6" data-id="element-162" data-mp="2lyjoswdsmywb">
                <p className="text-sm font-bold text-brand-green" data-id="element-163" data-mp="2h1jo70zpqocl">[Naam]</p>
                <p className="text-xs text-brand-gray" data-id="element-164" data-mp="1af4i8zemw1h">[Club / Rol]</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}